import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetReceiptJuniorPilotEffect } from './get-receipt-junior-pilot.effect';
import { getReceiptJuniorPilotReducer } from './get-receipt-junior-pilot.reducer';
import { GET_RECEIPT_JUNIOR_PILOT_STORE_NAME, GetReceiptJuniorPilotState } from './get-receipt-junior-pilot.state';

/** Token of the GetReceiptJuniorPilot reducer */
export const GET_RECEIPT_JUNIOR_PILOT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<GetReceiptJuniorPilotState, Action>
>('Feature GetReceiptJuniorPilot Reducer');

/** Provide default reducer for GetReceiptJuniorPilot store */
export function getDefaultGetReceiptJuniorPilotReducer() {
  return getReceiptJuniorPilotReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_RECEIPT_JUNIOR_PILOT_STORE_NAME, GET_RECEIPT_JUNIOR_PILOT_REDUCER_TOKEN),
    EffectsModule.forFeature([GetReceiptJuniorPilotEffect]),
  ],
  providers: [{ provide: GET_RECEIPT_JUNIOR_PILOT_REDUCER_TOKEN, useFactory: getDefaultGetReceiptJuniorPilotReducer }],
})
export class GetReceiptJuniorPilotStoreModule {
  public static forRoot<T extends GetReceiptJuniorPilotState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetReceiptJuniorPilotStoreModule> {
    return {
      ngModule: GetReceiptJuniorPilotStoreModule,
      providers: [{ provide: GET_RECEIPT_JUNIOR_PILOT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
